import * as PourOver from 'pourover';

import { FilterBase, orIn, andIn } from './FilterBase';


export class FormularyPricingFilter extends FilterBase {

      needsSubset = true;
      formulary:any;
      nonformulary:any;

  constructor() {
    super();
  }

  makeIndex(): any {
    return new PourOver.makeInclusionFilter('formularyPricingType', [
      'formulary',
      'nonformulary',
    ]);

  }

  // matching collection set


  getMatchSet(collection: any, filterSettings): any {
      let union = null;

      this.formulary = collection.filters.formularyPricingType.getFn('formulary');
      this.nonformulary = collection.filters.formularyPricingType.getFn('nonformulary');

      if (filterSettings.showFormularyPricing) {
        union = orIn(union, this.formulary);

      }
      if (filterSettings.showNonFormularyPricing) {
        union = orIn(union, this.nonformulary);

      }
      return union;

  }

// return total count of products with formulary price

getCounts(filterCombinations): any {

      let temp = andIn(
      filterCombinations.subsets[this.constructor.name],
      filterCombinations.incumbentsFilter,
    );

      return {
      formularyPricing: andIn(temp, this.formulary).cids.length,
      nonFormularyPricing: andIn(temp, this.nonformulary).cids.length,
    };
  }
}
